import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SplitButtonComponent } from './split-button.component';
@NgModule({
  imports: [CommonModule],
  declarations: [SplitButtonComponent],
  exports: [SplitButtonComponent],
})
export class CrSplitBtnModule {}
